import { useSelector } from 'react-redux';

export const useNumberFormatter = () => {
    const currentLanguage = useSelector((state) => state.translation.language) || 'en';

  const localeMap = {
    en: 'en-US',
    es: 'es-ES',
    de: 'de-DE',
    fr: 'fr-FR',
    pt: 'pt-PT',
    hi: 'hi-In-u-nu-deva',
    zh: 'zh-CN',
    ru: 'ru-RU',
    tr: 'tr-TR',
    ko: 'ko-KR',
    ja: 'ja-JP',
    it: 'it-IT',
    id: 'id-ID',
    vi: 'vi-VN',
    ar: 'ar-EG', // You can change to 'ar-SA' if preferred
  };

  const formatNumber = (num, options = {}) => {
    if (num === null || num === undefined) return '';

    const locale = localeMap[currentLanguage] || 'en-US'; // fallback to en-US
    
    // Default options with useGrouping set to false
    const defaultOptions = { useGrouping: false };
    
    // Merge default options with any custom options passed
    const formatterOptions = { ...defaultOptions, ...options };

    try {
      return new Intl.NumberFormat(locale, formatterOptions).format(num);
    } catch (error) {
      console.error(`Number formatting error for language: ${locale}`, error);
      return num;
    }
  };

  return { formatNumber };
};
